export default "__VITE_ASSET__Tt7$1Y_n__"